export default "__VITE_ASSET__CZW8uB2u__"